<template>

    <nav>
        <ul class="pagination">
            <li v-if="page > 1">
                <a href="#" aria-label="Previous" @click.prevent="changePage(0)">
                    <span aria-hidden="true">«</span>
                </a>
            </li>
            <li v-if="page > 5">
                <a href="#" @click.prevent="nextPages(index-1)">
                    <span aria-hidden="true">...</span>
                </a>
            </li>
            <li v-for="_page in paginationPages" :class="{'active': (_page + (index*5))-1 == (page)}">
                <a href="#" v-show="((_page + (index*5))-1) <= totalPages" @click.prevent="changePage((_page + (index*5))-1)">{{ _page + (index*5) }}</a>
            </li>
            <li v-if="totalPages > 5 && ((totalPages-page) >= 5)">
                <a href="#" @click.prevent="nextPages(index+1)">
                    <span aria-hidden="true">...</span>
                </a>
            </li>
            <li v-if="totalPages > 5 && page != totalPages">
                <a href="#" aria-label="Next" @click.prevent="lastPage()">
                    <span aria-hidden="true">»</span>
                </a>
            </li>
        </ul>
    </nav>

</template>

<script>
    export default{
        props: {
            pagination: {
                type: Object,
                required: true
            },
            current: {
                type: Number,
                default: 0
            },
            offset: {
                type: [Number, String],
                default: 20
            }
        },
        data() {
            return {
                totalPages: 0,
                paginationPages: 0,
                index: 0,
                page: 0
            }
        },
        created() {
            this.page = this.current;
        },
        watch: {
            pagination: function () {
                this.totalPages = Math.ceil(this.pagination.count/this.offset)-1;
                this.paginationPages = (this.totalPages > 5 ? 5 : (this.totalPages+1));
            },
            // current: function () {
            //     this.page = this.current;
            // },
            offset: function () {
                this.page = 0;
                this.index = 0;
            }
        },
        methods: {
            changePage: function (page) {
                this.page = page;
                if (page == 0) {
                    this.index = 0;
                    this.paginationPages = (this.totalPages > 5 ? 5 : (this.totalPages+1));
                    // this.paginationPages = (this.totalPages - this.page) > 5 ? 5 : (this.totalPages - this.page);
                }
                this.$emit('update', page);
            },
            nextPages: function (newIndex) {
                this.index = newIndex;
                this.page = (newIndex * 5);
                this.paginationPages = (this.totalPages - this.page) > 5 ? 5 : (this.totalPages - this.page);
                this.$emit('update', this.page);
            },
            lastPage: function () {
                this.index = Math.ceil(this.totalPages/5)-1;
                this.paginationPages = (this.totalPages - this.page) > 5 ? 5 : (this.totalPages - this.page);
                this.page = this.totalPages;
                this.$emit('update', this.page);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DWPagination.vue?23974355